// extracted by mini-css-extract-plugin
module.exports = {"outer":"profile_outer__9He8F","profileWrapper":"profile_profileWrapper__Uk8gI","avatar":"profile_avatar__KZUCj","menu":"profile_menu__4Ftrb","menuItem":"profile_menuItem__1_bsq"};